var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view-frame"},[_c('header',{staticClass:"view-frame__header"},[_c('div',{staticClass:"view-frame__header__left"},[(_vm.titleObject.show)?_c('span',[_vm._v(_vm._s(_vm.titleObject.title + _vm.titleObject.data || ''))]):_vm._e()]),_c('div',{staticClass:"view-frame__header__right"},[_vm._t("rightBtn")],2)]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }